import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Landing from "./views/Landing.vue";
import galerie from "@/views/galerie";
import admin from "@/views/admin";
import Service from "@/views/Service";
import Team from "./views/Team.vue";
import Contact from "./views/Contact.vue";
import Realisations from "./views/Realisations.vue";
import Produits from "./views/Produits.vue";
import supportPublicitaire from "./views/support-publicitaire.vue";
import veloPublicitaire from "./views/velo-publicitaire.vue";
import movingBoard from "./views/moving-board.vue"


Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  mode: 'history',
  routes: [
    {
      path: "/",
      name: "landing",
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter,
      },
    },
    {
      path: "/support-publicitaire-benin",
      name: "support publicitaire Bénin",
      components: {
        header: AppHeader,
        default: supportPublicitaire,
        footer: AppFooter,
      },
    },
    {
      path: "/galerie",
      name: "galerie",
      components: {
        header: AppHeader,
        default: galerie,
        footer: AppFooter,
      },
    },
    {
      path: "/admin",
      name: "admin",
      components: {
        header: AppHeader,
        default: admin,
        footer: AppFooter,
      },
    },
    {
      path: "/service",
      name: "service",
      components: {
        header: AppHeader,
        default: Service,
        footer: AppFooter,
      },
    },
    {
      path: "/equipe",
      name: "equipe",
      components: {
        header: AppHeader,
        default: Team,
        footer: AppFooter,
      },
    },
    {
      path: "/contact",
      name: "contact",
      components: {
        header: AppHeader,
        default: Contact,
        footer: AppFooter,
      },
    },
    {
      path: "/realisations",
      name: "realisation",
      components: {
        header: AppHeader,
        default: Realisations,
        footer: AppFooter,
      },
    },
    {
      path: "/produits",
      name: "produits",
      components: {
        header: AppHeader,
        default: supportPublicitaire,
        footer: AppFooter,
      },
    },
    {
      path: "/velo-publicitaire-benin",
      name: "Vélo publicitaire Bénin",
      components: {
        header: AppHeader,
        default: veloPublicitaire,
        footer: AppFooter,
      },
    },
    {
      path: "/moving-board-benin",
      name: "Moving board publicitaire Bénin",
      components: {
        header: AppHeader,
        default: movingBoard,
        footer: AppFooter,
      },
    },
  ],
  // scrollBehavior(to, from, savedPosition) {
  //   if (savedPosition) {
  //     return savedPosition;
  //   } else if (to.hash) {
  //     return { selector: to.hash };
  //   } else {
  //     return { x: 0, y: 0 };
  //   }
  // }
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
